<template>
  <div>
    <DashboardHeader title="SMS Dashboard">
      <div class="mx-4 mt-6">
        
        <v-row class="px-4" v-if="!isMobile">
          <v-col
            :cols="isMobile ? 12 : 3"
            v-for="(data, i) in smsAnalytics"
            :key="i + Math.random()"
          >
            <CardAlert :color="colors[i]">
              <v-icon left>{{ data.icon }}</v-icon> {{ data.text }}:
              {{ data.value }}
            </CardAlert>
          </v-col>
        </v-row>
        <v-expansion-panels v-else class="pb-4">
          <v-expansion-panel>
            <v-expansion-panel-header> SMS Analytics </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="px-4">
                <v-col
                  :cols="isMobile ? 12 : 3"
                  v-for="(data, i) in smsAnalytics"
                  :key="i + Math.random()"
                >
                  <CardAlert :color="colors[i]">
                    <v-icon left>{{ data.icon }}</v-icon> {{ data.text }}:
                    {{ data.value }}
                  </CardAlert>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <v-row class="mx-0">
        <v-col :cols="isMobile ? 12 : 4">
          <VirtualScrollCase
            class="mt-4"
            :itemHeigth="600"
            :items="[1]"
            :title="groupTable ? groupTable.toUpperCase() : 'Select Group'"
            :scrollHeigth="600"
          >
            <template #content>
              <SelectGroup @group-selected="getSelectedGroup"></SelectGroup>
              <CardAlert
                :color="getThemeColor"
                v-if="
                  groupTable &&
                  groupTable != 'staff' &&
                  groupTable != 'clients' &&
                  groupTable != 'users'
                "
                class="mt-4"
              >
                Add Contacts To {{ selectedGroup.name }}

                <input
                  placeholder="Contact Name"
                  type="text"
                  size="20"
                  class="mt-4"
                  @blur="newContactName = $event.target.value"
                  :style="{
                    color: 'white',
                    border: 'none',
                    'border-bottom': '1px solid white',
                    'margin-top': '4px',
                  }"
                />
                <br />
                <input
                  placeholder="012 345 6789"
                  type="text"
                  size="14"
                  class="mt-4"
                  @blur="newPhoneNumber = $event.target.value"
                  :style="{
                    color: 'white',
                    border: 'none',
                    'border-bottom': '1px solid white',
                    'margin-top': '4px',
                  }"
                /><v-btn
                  rounded
                  x-small
                  class="ml-2"
                  outlined
                  @click="addContactToContactsTable()"
                  ><v-icon x-small>mdi-plus</v-icon></v-btn
                >
              </CardAlert>
            </template>
          </VirtualScrollCase>
        </v-col>
        <v-col :cols="isMobile ? 12 : 4">
          <v-card class="mt-4 mx-1">
            <v-toolbar color class="mb-1">
              <v-toolbar-title :style="{ color: getOutlineColor }">{{
                groupTable ? groupTable.toUpperCase() : "Group"
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-switch
                v-model="groupMembersSwitch"
                class="mt-6 mr-2"
                label="All"
                @change="selectAllGroupMembersWhenSwitchIsTrue()"
              ></v-switch>
              <v-icon
                color="red"
                class="ml-4"
                @click="openConfirmDeleteDialog('contacts')"
                v-if="
                  groupTable &&
                  groupTable != 'staff' &&
                  groupTable != 'clients' &&
                  groupTable != 'users'
                "
                >mdi-delete</v-icon
              >
            </v-toolbar>

            <v-virtual-scroll
              :items="selectedGroupMembers"
              height="600"
              item-height="130"
            >
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-list-item-title v-if="props.item.name" class="mb-4">{{
                        props.item.name
                      }}</v-list-item-title>

                      <v-list-item-title v-if="props.item.phone">
                        <input
                          :style="{
                            border: 'none',
                            'border-bottom': '1px solid black',
                          }"
                          :value="props.item.phone"
                          @blur="updatePhoneNumber(props.item)"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-if="props.item.phone_number">
                        <input
                          :style="{
                            border: 'none',
                            'border-bottom': '1px solid black',
                          }"
                          :value="props.item.phone_number"
                          @blur="updatePhoneNumber(props.item)"
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        dense
                        class="shrink mx-n4"
                        :value="props.item.id"
                        v-model="selectedMembersForSMSSending"
                      ></v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? 12 : 4">
          <v-card class="mt-4 mx-1 pr-4">
            <v-toolbar color class="mb-1">
              <v-spacer></v-spacer>
              <v-switch
                v-model="reportsSwitch"
                class="mt-7 mr-2"
                label="All"
                @change="selectAllReportsWhenSwitchIsTrue()"
              ></v-switch>

              <v-btn
                color="green"
                dark
                x-small
                rounded
                @click="openSendSMSDialog()"
                ><v-icon left>mdi-comment</v-icon>Create</v-btn
              >
              <v-icon
                color="red"
                class="mt-1"
                @click="openConfirmDeleteDialog('reports')"
                >mdi-delete</v-icon
              >
            </v-toolbar>

            <v-virtual-scroll :items="sentSMSes" height="600" item-height="130">
              <template v-slot:default="props">
                <v-list two-line>
                  <v-list-item :key="props.index + Math.random()">
                    <v-list-item-content>
                      <v-list-item-title class="mb-1">{{
                        props.item.title
                      }}</v-list-item-title>
                      <v-list-item-subtitle class="mb-2">{{
                        props.item.date_time
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        {{ props.item.body }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Sent: {{ props.item.sent }} | Delivered:
                        {{ props.item.delivered }} | Rejected:
                        {{ props.item.rejected }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectedReportsForDeleting"
                        :value="props.item.id"
                        class="shrink mb-n4"
                        dense
                      >
                      </v-checkbox>
                      <v-btn
                        color="teal"
                        x-small
                        dark
                        rounded
                        class="mb-2 mx-n4"
                        @click="reSendSMS(props.item)"
                        >Resend</v-btn
                      >
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>
      </v-row>
    </DashboardHeader>
    <GlobalDialogSlot
      :dialog="dialog"
      :title="sendSMSTitle"
      @close-dialog="closeDialog"
    >
      <SendSMS
        v-if="bulkSMS"
        :groupTable="groupTable"
        :recipientsIDs="selectedMembersForSMSSending"
        @refresh-needed="refreshAnalyticsData"
        :selectedSentSMSItem="selectedSentSMSItem"
      ></SendSMS>
    </GlobalDialogSlot>

    <GlobalConfirmDeleteDialog
      @delete-confirmed="deleteSelectedItemsNow"
      :item="'Selected ' + itemTitle"
    ></GlobalConfirmDeleteDialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";
import VirtualScrollCase from "@/components/myLibrary/VirtualScrollCase.vue";
import SelectGroup from "@/components/SMS/SelectGroup.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import SendSMS from "@/components/SMS/SendSMS.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  components: {
    
    DashboardHeader,
    CardAlert,
    VirtualScrollCase,
    SelectGroup,
    GlobalConfirmDeleteDialog,
    SendSMS,
    GlobalDialogSlot,
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  mounted() {
    this.getDataAndAnalytics();
  },
  data: () => ({
    selectedSentSMSItem: null,
    dialog: false,
    bulkSMS: false,
    sendSMSTitle: null,
    smsCredits: null,
    searchSMS: null,
    groupTable: null,
    colors: ["warning", "primary", "#1B5E20", "red", "#3E2723"],
    groupMembersSwitch: false,
    reportsSwitch: false,
    selectedGroup: null,
    searchMembers: null,
    selectedGroupMembers: [],
    selectedReportsForDeleting: [],
    selectedMembersForSMSSending: [],
    selectedGroupMembersHeaders: [],
    newPhoneNumber: null,
    newContactName: null,
    deleteItemTable: null,
    itemTitle: null,
    rowIds: [],
    sentSMSes: [],
    smsAnalytics: [
      { icon: "mdi-cash", text: "Credits", value: 0 },
      { icon: "mdi-comment", text: "Sent", value: 0 },
      { icon: "mdi-check", text: "Delivered", value: 0 },
      { icon: "mdi-close", text: "Rejected", value: 0 },
    ],
    sentSMSesHeaders: [
      { value: "id" },
      { text: "Date & Time", value: "date_time" },
      { text: "Title", value: "title" },
      { text: "SMS", value: "body" },
      { text: "Sent", value: "sent" },
      { text: "Delivered", value: "delivered" },
      { text: "Rejected", value: "rejected" },
    ],
  }),
  methods: {
    refreshAnalyticsData() {
      this.closeDialog();
      this.getDataAndAnalytics();
    },
    getDataAndAnalytics() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-data-and-analytics", this.getAccessToken)
        .then((data) => {
          this.selectedReportsForDeleting = [];
          this.selectedSentSMSItem = null;
          this.smsCredits = data.credits;
          this.smsAnalytics[0].value = data.credits;
          this.smsAnalytics[1].value = data.sent;
          this.smsAnalytics[2].value = data.delivered;
          this.smsAnalytics[3].value = data.rejected;
          this.smsAnalytics[4].value = data.scheduled;
          this.sentSMSes = data.sentSMSes;
          this.$store.commit("setLoader", false);
        });
    },
    updatePhoneNumber(item) {
      let column = "";
      if (this.groupTable && this.groupTable == "staff") {
        column = "phone";
        this.updateField(this.groupTable, column, item.phone, item.id);
      } else if (this.groupTable && this.groupTable == "clients") {
        column = "phone";
        this.updateField(this.groupTable, column, item.phone, item.id);
      } else if (this.groupTable && this.groupTable == "users") {
        column = "phone_number";
        this.updateField(this.groupTable, column, item.phone_number, item.id);
      }
    },
    updateField(table, column, value, id) {
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table, column, id, value },
          this.getAccessToken
        )
        .then((response) => {
          const res = response;
        });
    },
    selectAllGroupMembersWhenSwitchIsTrue() {
      if (this.groupMembersSwitch) {
        this.selectedMembersForSMSSending = [];
        this.selectedGroupMembers.forEach((groupMember) => {
          this.selectedMembersForSMSSending.push(groupMember.id);
        });
      } else {
        this.selectedMembersForSMSSending = [];
      }
    },
    selectAllReportsWhenSwitchIsTrue() {
      if (this.reportsSwitch) {
        this.selectedReportsForDeleting = [];
        this.sentSMSes.forEach((sms) => {
          this.selectedReportsForDeleting.push(sms.id);
        });
      } else {
        this.selectedReportsForDeleting = [];
      }
    },
    selectAllGroupMembers() {
      this.selectedMembersForSMSSending = [];
      this.selectedGroupMembers.forEach((groupMember) => {
        this.selectedMembersForSMSSending.push(groupMember.id);
      });
      this.groupMembersSwitch = true;
    },
    getSelectedGroup(selectedGroup) {
      this.selectedGroup = selectedGroup;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-selected-group-members",
          { selectedGroupID: selectedGroup.id },
          this.getAccessToken
        )
        .then((selectedGroupMembers) => {
          if (this.selectedGroup.id == "1000000") {
            this.groupTable = "staff";
            this.selectedGroupMembersHeaders = [
              { text: "Action", value: "id" },
              { text: "Name", value: "name" },
            ];
            this.selectedGroupMembersHeaders.push({
              text: "Number",
              value: "phone",
            });
          } else if (this.selectedGroup.id == "1000001") {
            this.groupTable = "clients";
            this.selectedGroupMembersHeaders = [
              { text: "Action", value: "id" },
              { text: "Name", value: "name" },
            ];
            this.selectedGroupMembersHeaders.push({
              text: "Number",
              value: "phone",
            });
          } else if (this.selectedGroup.id == "1000002") {
            this.groupTable = "users";
            this.selectedGroupMembersHeaders = [
              { text: "Action", value: "id" },
              { text: "Name", value: "name" },
            ];
            this.selectedGroupMembersHeaders.push({
              text: "Number",
              value: "phone_number",
            });
          } else {
            this.groupTable = "sms_contacts";
            this.selectedGroupMembersHeaders = [
              { text: "Action", value: "id" },
              { text: "Name", value: "name" },
            ];
            this.selectedGroupMembersHeaders.push({
              text: "Number",
              value: "phone_number",
            });
          }

          this.selectedGroupMembers = selectedGroupMembers;

          this.selectAllGroupMembers();
          this.$store.commit("setLoader", false);
        });
    },
    reSendSMS(item) {
      this.selectedSentSMSItem = item;
      this.dialog = true;
      this.bulkSMS = true;
      this.sendSMSTitle =
        "Resend SMS To " + this.item.delivered + " Recipients";
    },
    openSendSMSDialog() {
      this.dialog = true;
      this.bulkSMS = true;
      this.sendSMSTitle =
        this.selectedMembersForSMSSending.length > 0
          ? "Send SMS To " +
            this.selectedMembersForSMSSending.length +
            " Recipients"
          : "Send SMS To Unsaved Numbers";
    },
    openConfirmDeleteDialog(itemType) {
      if (itemType == "reports") {
        if (this.selectedReportsForDeleting.length < 1) {
          alert("Select Aleast 1 Report");
          event.preventDefault();
          return null;
        } else {
          this.deleteItemTable = "sms_sent";
          this.rowIds = this.selectedReportsForDeleting;
          this.itemTitle =
            this.selectedReportsForDeleting.length > 1 ? "Reports" : "Report";

          this.$store.commit("setGlobalConfirmDelete", true);
        }
      } else {
        if (this.selectedMembersForSMSSending.length < 1) {
          alert("Select Aleast 1 Contact");
          event.preventDefault();
          return null;
        } else {
          this.deleteItemTable = this.groupTable;
          this.rowIds = this.selectedMembersForSMSSending;
          this.itemTitle =
            this.selectedMembersForSMSSending.length > 1
              ? "Contacts"
              : "Contact";
          this.$store.commit("setGlobalConfirmDelete", true);
        }
      }
    },
    deleteSelectedItemsNow(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/bulk-delete",
            {
              table: this.deleteItemTable,
              rowIds: this.rowIds,
            },
            this.getAccessToken
          )
          .then(() => {
            this.$store.commit("setGlobalConfirmDelete", false);
            if (this.selectedGroup) {
              this.getSelectedGroup(this.selectedGroup);
            }
            this.getDataAndAnalytics();
          });
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
    addContactToContactsTable() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-new-contact",
          {
            newPhoneNumber: this.newPhoneNumber,
            newContactName: this.newContactName,
            groupID: this.selectedGroup.id,
          },
          this.getAccessToken
        )
        .then((data) => {
          this.getSelectedGroup(this.selectedGroup);
        });
    },
    closeDialog() {
      this.dialog = false;
      this.bulkSMS = false;
      this.sendSMSTitle = null;
      this.selectedSentSMSItem = null;
    },
  },
};
</script>

<style></style>
